module.exports = __webpack_public_path__ + "static/media/question-icon-white.1fd7e23b.png";